export const STUDIO_REFERRER = 'studio';

/** Skips Studio get-started when resuming from an existing workspace session. */
export const STUDIO_STEP_PARAM = 'studio_step';
export const STUDIO_STEP_EMAIL_VERIFICATION = 'email-verification';
export const STUDIO_STEP_WORKSPACE_SETUP = 'workspace-setup';

/** Query flag marking the Google OAuth return after Studio workspace creation. */
export const STUDIO_POST_CREATE_PARAM = 'studio_post_create';
export const STUDIO_POST_CREATE_VALUE = '1';
export const STUDIO_POST_CREATE_PORTAL_HEADER_PARAM = 'portal_header';
export const STUDIO_POST_CREATE_PORTAL_URL_PARAM = 'portal_url';
